import React from "react"
import { Grid, CmsImage } from "@bw/bits"
import { Teaser } from "@bw/partials"
import useVideoCollection from "../../../../hooks/useVideoCollection"

const Videos = () => {
  const videos = useVideoCollection()
  return (
    <Grid>
      {videos.map(video => {
        return (
          <Teaser
            title={video.title}
            excerpt={video.teaserText}
            to={video.url}
            image={
              video.poster ? (
                <CmsImage src={video.poster} alt={video?.poster?.alt} />
              ) : undefined
            }
          />
        )
      })}
    </Grid>
  )
}

export { Videos }
